import React from "react";
import { Outlet, Navigate } from "react-router-dom";


const AdminRoutes = () => {
    let auth = {'token':false}

    if(localStorage.getItem('user-info')){
        auth = {'token':true}
      }
    return(
        auth.token ? <Outlet/> : <Navigate to="/login"/>
    )
}
export default AdminRoutes;